export const APPLICATION_CONSTANTS = {

    //KEYS
    REMEMBER_ME_SECRETE_KEY: "remembermesecret$#",
    REMEMBER_USER_SECRETE_KEY: "UserSecretKey",
}
